import { API } from "../../apiSlice";

export const getUserDepositsApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getUserDeposits: builder.query({
      query: () => {
        return {
          url: "users/deposits",
        };
      },
    }),
  }),
});

export const { useGetUserDepositsQuery } = getUserDepositsApiSlice;
